import CartOutlineIcon from '@eduzz/houston-icons/CartOutline';
import DashboardBarIcon from '@eduzz/houston-icons/DashboardBar';
import DashboardRoundOutlineIcon from '@eduzz/houston-icons/DashboardRoundOutline';
import FolderOutlineIcon from '@eduzz/houston-icons/FolderOutline';
import HelpOutlineIcon from '@eduzz/houston-icons/HelpOutline';
import LampOutlineIcon from '@eduzz/houston-icons/LampOutline';
import MoneyIcon from '@eduzz/houston-icons/Money';
import ParametersIcon from '@eduzz/houston-icons/Parameters';
import SettingsOutlineIcon from '@eduzz/houston-icons/SettingsOutline';
import React from 'react';

type RouteNode = {
  to: string;
  label: string;
  permission?: string;
  isUnityExclusive?: boolean;
  betaModule?: string;
  tour?: string;
};

export type Route = {
  to?: string;
  label: string;
  icon?: React.ReactNode;
  nodes?: RouteNode[];
  permission?: string;
  userTypes?: string[];
  isUnityExclusive?: boolean;
  accessPerBelt?: number[];
  betaModule?: string;
  tour?: string;
  external?: boolean;
};

const routes: Route[] = [
  {
    to: '/producer/dashboard',
    label: 'Dashboard',
    icon: <DashboardRoundOutlineIcon size={24} />,
  },
  {
    to: '/producer/shopping',
    label: 'Compras',
    icon: <MoneyIcon size={24} />,
    userTypes: ['onlyCustomer'],
  },
  {
    label: 'Vendas',
    icon: <CartOutlineIcon size={24} />,
    userTypes: ['producer', 'affiliate'],
    nodes: [
      {
        to: '/producer/sales',
        label: 'Minhas Vendas',
        permission: 'myeduzz:minhas-vendas:visualizar',
      },
      {
        to: '/producer/leads',
        label: 'Meus Leads',
        permission: 'myeduzz:meus-leads:visualizar',
      },
      {
        to: '/producer/subscriptions',
        label: 'Meus Contratos',
        permission: 'myeduzz:meus-contratos:visualizar',
      },
      {
        to: '/producer/myaffiliates',
        label: 'Meus Afiliados',
        permission: 'myeduzz:meus-afiliados:visualizar',
      },
      {
        to: '/producer/orders',
        label: 'Minhas Entregas',
        permission: 'myeduzz:minhas-entregas:visualizar',
      },
      {
        to: '/producer/whitelist',
        label: 'Whitelist',
        permission: 'myeduzz:whitelist:visualizar',
      },
      {
        to: '/producer/request-management',
        label: 'Ações Pendentes',
        permission: 'myeduzz:requestmanagement:visualizar',
      },
    ],
  },
  {
    label: 'Produtos',
    icon: <FolderOutlineIcon size={24} />,
    userTypes: ['producer', 'affiliate'],
    nodes: [
      {
        to: '/producer/product/myproducts',
        label: 'Meus Produtos',
        permission: 'myeduzz:meus-produtos:visualizar',
      },
      {
        to: '/producer/affiliations',
        label: 'Minhas Afiliações',
        permission: 'myeduzz:meus-afiliados:visualizar',
      },
      {
        to: '/producer/campaigns',
        label: 'Links',
        permission: 'myeduzz:links:visualizar',
      },
    ],
  },
  {
    label: 'Financeiro',
    icon: <MoneyIcon size={24} />,
    userTypes: ['producer', 'affiliate'],
    nodes: [
      {
        to: '/producer/financial-statement',
        label: 'Extrato',
        permission: 'myeduzz:financeiro:visualizar',
      },
    ],
  },
  {
    to: '/producer/reports/sales',
    label: 'Relatórios',
    icon: <DashboardBarIcon size={24} />,
    userTypes: ['producer'],
    tour: 'new_sales_reports',
    permission: 'myeduzz:reports:visualizar',
  },
  {
    to: 'https://space.eduzz.com',
    label: 'Soluções',
    icon: <LampOutlineIcon size={24} />,
    userTypes: ['producer', 'affiliate'],
    permission: 'no-access-control-permission',
    external: true,
  },
  {
    label: 'Integrações',
    icon: <SettingsOutlineIcon size={24} />,
    userTypes: ['producer', 'affiliate'],
    nodes: [
      {
        to: '/producer/config-api',
        label: 'Configurações da API',
        permission: 'no-access-control-permission',
      },
      {
        to: '/producer/cdf',
        label: 'Central de Documentos Fiscais',
        permission: 'myeduzz:cdf:visualizar',
      },
      {
        to: '/producer/connect/myconnects',
        label: 'Connect',
        permission: 'myeduzz:connect:visualizar',
      },
      {
        to: '/producer/new-connect',
        label: 'Novo Connect',
        permission: 'myeduzz:connect:visualizar',
        betaModule: 'new_connect',
      },
      {
        to: '/producer/webhook',
        label: 'Webhooks',
        permission: 'myeduzz:webhook:visualizar',
      },
    ],
  },
  {
    label: 'Configurações',
    icon: <ParametersIcon size={24} />,
    userTypes: ['producer'],
    nodes: [
      {
        to: '/producer/access',
        label: 'Controle de Acesso',
        permission: 'no-access-control-permission',
      },
    ],
  },
  {
    to: '/producer/help',
    label: 'Ajuda',
    icon: <HelpOutlineIcon size={24} />,
    permission: 'myeduzz:ajuda:visualizar',
  },
];

export { routes };
